import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { ConvensionalBidSchema } from "../../components/common/validations/Validation";
import TextField from "../../components/common/formInput/TextField";
import { options, message, _status, pagination } from "../../components/common/utils/message";
import { alert, confirm } from "react-bootstrap-confirmation";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Get_State, Get_Countries } from "../../services/owner";
import SearchSelectBox from "../../components/common/formInput/SearchSelectBox";
import { listProjects } from "../../services/project";
import { addBid, updateBid, viewOneBid } from '../../services/convensionalBid';
import { failed, success } from "../../components/common/Toastify";
import queryString from 'query-string';

const BidForm = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const [resPayload, setResPayload] = useState();
    const [resProjects, setResProjects] = useState();

    const [resStates, setResStates] = useState();
    const [resCountries, setResCountries] = useState();

    const paramID = queryString.parse(location.search)

    useEffect(() => {
        listProjects({ page: pagination.page }, (data) => { setResProjects(data) }, dispatch)
        viewOneBid(paramID, (data) => { setResPayload(data) }, dispatch);
        Get_Countries(result => { setResCountries(result.data) }, dispatch);
    }, []);

    let countryData = resCountries?.map((item) => ({ value: item.name, label: item.name }));
    let projectData = resProjects?.docs.map((item) => ({ value: item._id, label: item.project_title }));

    const initialData = {
        _id: resPayload ? resPayload._id : "",
        first_name: resPayload ? resPayload.first_name : "",
        last_name: resPayload ? resPayload.last_name : "",
        company_name: resPayload ? resPayload.company_name : "",
        city: resPayload ? resPayload.city : "",
        phone: resPayload ? resPayload.phone : "",
        state: resPayload ? resPayload.state : "",
        country: resPayload ? resPayload.country : "",
        zip_code: resPayload ? resPayload.zip_code : "",
        address1: resPayload ? resPayload.address1 : "",
        address2: resPayload ? resPayload.address2 : "",
        email: resPayload ? resPayload.email : "",
        project_Id: resPayload ? resPayload.project_Id : "",
        status: resPayload ? resPayload.status : ""
    };

    /**
     * @description Function is for add bid.
     * @param {object} data 
     */
    const _submitData = (data) => {
        try {
            addBid(data, result => {
                if (result.status === "SUCCESS" && result.code === 200) {
                    success(result.message);
                    navigate("/list-bid");
                } else if (result.status === "ERROR" && result.code === 403) {
                    failed(result.message)
                }
            }, dispatch)
        } catch (e) {
            failed(e)
        }

    };

    /**
    * @description Function is for edit bid.
    * @param {object} data 
    */
    const _updateData = (data) => {
        try {
            updateBid(data, result => {
                if (result.status === "SUCCESS" && result.code === 200) {
                    success(result.message);
                    navigate("/list-bid");
                } else if (result.status === "ERROR" && result.code === 403) {
                    failed(result.message)
                }
            }, dispatch)
        } catch (e) {
            failed(e)
        }

    };

    /**
     * @description Function is For on Cancel Confirm Box.
     */
    const onCancel = async () => {
        const result = await confirm(message.cancelForm, options);
        if (result) {
            // alert(message.cancelBidForm);
            navigate("/list-bid");
        }
    };

    return (
        <div className="dashboard-inner p-b-0">
            <Formik
                initialValues={initialData}
                enableReinitialize
                validationSchema={ConvensionalBidSchema}
                onSubmit={(values) => resPayload ? _updateData(values) : _submitData(values)}
            >
                {(formik) => (
                    <Form>
                        <div className="d-card m-b-25">
                            <div className="d-card-header">
                                <h5 className="d-card-heading">{resPayload ? "Edit Bid" : "Add Bid"}</h5>
                            </div>
                            <div className="d-card-body p-b-0">
                                <div className="form-content">
                                    <div className="f-row alignTop">
                                        <div className="f-33">
                                            <SearchSelectBox
                                                label="Project"
                                                placeholder="Select Project"
                                                name="project_Id"
                                                value={formik?.values?.project_Id}
                                                onChange={formik.handleChange}
                                                required={true}
                                                options={projectData}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <TextField
                                                label="First Name"
                                                placeholder="First Name"
                                                name="first_name"
                                                value={formik?.values?.first_name}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <TextField
                                                label="Last Name"
                                                placeholder="Last Name"
                                                name="last_name"
                                                value={formik?.values?.last_name}
                                                onChange={formik.handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="f-row alignTop">
                                        <div className="f-33">
                                            <TextField
                                                label="Email Address"
                                                placeholder="Email Address"
                                                name="email"
                                                value={formik?.values?.email}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <TextField
                                                label="Phone"
                                                name="phone"
                                                value={formik?.values?.phone}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <SearchSelectBox
                                                label="Country"
                                                placeholder="Select Country"
                                                name="country"
                                                value={formik?.values?.country}
                                                onChange={formik.handleChange}
                                                changeHandle={(val) => {
                                                    Get_State({ country: val }, result => {
                                                        setResStates(result?.data?.states?.map((item) => ({ value: item.name, label: item.name })));
                                                    }, dispatch)
                                                }}
                                                required={true}
                                                options={countryData}
                                            />
                                        </div>
                                    </div>
                                    <div className="f-row alignTop">
                                        <div className="f-33">
                                            <SearchSelectBox
                                                label="State"
                                                placeholder="Select States"
                                                name="state"
                                                value={formik?.values?.state}
                                                onChange={formik.handleChange}
                                                required={true}
                                                options={resStates}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <TextField
                                                label="Address Line 1"
                                                name="address1"
                                                value={formik?.values?.address1}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <TextField
                                                label="Address Line 2"
                                                name="address2"
                                                value={formik?.values?.address2}
                                                onChange={formik.handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="f-row alignTop">
                                        <div className="f-33">
                                            <TextField
                                                label="City"
                                                name="city"
                                                value={formik?.values?.city}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <TextField
                                                label="Zip Code"
                                                name="zip_code"
                                                value={formik?.values?.zip_code}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <TextField
                                                label="Company Name"
                                                name="company_name"
                                                value={formik?.values?.company_name}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <SearchSelectBox
                                                label="Status"
                                                name="status"
                                                options={_status}
                                                value={formik?.values?.status}
                                                onChange={formik.handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-card-bottom">
                            <div className="d-card-bottom-cell">
                                <button className="btn btn-blue" type="submit">{resPayload ? "Edit" : "Bid"}</button>
                            </div>
                            <div className="d-card-bottom-cell">
                                <button className="btn btn-grey" onClick={onCancel} type="button"> Cancel </button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default BidForm;
